// extracted by mini-css-extract-plugin
module.exports = {"widgetsSectionHeader":"WidgetsSectionHeader_widgetsSectionHeader__1fQlo","headerLeft":"WidgetsSectionHeader_headerLeft__1yF_q"};